module.exports = __webpack_public_path__ + "img/back-arrow.aadb07a4.svg";